{
  "resource.label": "Плод",
  "resource.node": "Плодовая жила",
  "resource.insufficient": "Недостаточно Плода",
  "unit.worker": "Engineer",
  "unit.melee": "Wheeled IFV",
  "unit.ranged": "Heavy Tank",
  "unit.siege": "Self-Propelled Artillery",
  "worker.task.idle": "Ожидание",
  "worker.task.moveToNode": "Переход к жиле",
  "worker.task.gathering": "Жатва",
  "worker.task.moveToHq": "Возврат",
  "worker.task.depositing": "Плод принят",
  "worker.task.building": "Выращивание",
  "entity.hq": "Command Hub",
  "entity.barracks": "Field Factory",
  "entity.mineral": "Плодовая жила",
  "command.train.worker": "Train Engineer",
  "command.train.melee": "Produce IFV",
  "command.train.ranged": "Produce Heavy Tank",
  "command.train.siege": "Produce Artillery",
  "command.buildBarracks": "Build Factory",
  "command.buildBarracks.unlocks": "Unlocks:",
  "command.stop": "Стоп",
  "command.move": "Марш",
  "command.attack": "Атака",
  "command.hold": "Удерживать",
  "command.harvest": "Собирать",
  "cursor.build": "Строительство",
  "hotkey.assign": "Назначить",
  "hotkey.recall": "Вызвать",
  "hotkey.add": "Добавить",
  "alert.invalidBuildPlacement": "Нельзя строить здесь",
  "alert.underAttack": "Штаб под атакой",
  "hud.minimap.label": "Мини-карта",
  "selection.none": "Нет выбора",
  "selection.units": "ед.",
  "stat.role": "Роль",
  "stat.hp": "ОЗ",
  "stat.damage": "Урон",
  "stat.range": "Дальность",
  "stat.rangeShort": "Дальн.",
  "stat.aoe": "Область",
  "stat.aoeShort": "Обл.",
  "stat.speed": "Скорость (клеток/с)",
  "stat.speedShort": "Скор. (клеток/с)",
  "stat.cooldown": "Перезарядка",
  "stat.cooldownShort": "КД",
  "stat.cost": "Цена",
  "stat.trainTime": "Подготовка",
  "stat.strongVs": "Силен против",
  "stat.weakVs": "Слаб против",
  "stat.strong": "Силен",
  "stat.weak": "Слаб",
  "stat.cargo": "Груз",
  "stat.none": "нет",
  "stat.secondsSuffix": "с",
  "stat.ticksSuffix": "тиков",
  "stat.ticksShortSuffix": "т",
  "counter.utility": "служебные цели",
  "counter.neutral": "нейтрально",
  "counter.buildings": "здания",
  "briefing.line": "Сад должен выжить. Плод сохранить, машины ФОК отбросить."
}
